import { MantineThemeOverride } from "@mantine/core";

const mantineTheme: MantineThemeOverride = {
  colors: {
    primary: [
      "#fff8ed",
      "#ffebcd",
      "#fed9aa",
      "#fdbe74",
      "#fb973c",
      "#f97916",
      "#ea5e0c",
      "#c2460c",
      "#9a3812",
      "#7c3012",
    ],

    secondary: [
      "#fff7ec",
      "#ffecd3",
      "#ffd6a5",
      "#ffb86d",
      "#ff8e32",
      "#ff6e0a",
      "#ff5400",
      "#cc3a02",
      "#a12e0b",
      "#82280c",
    ],

    tertiary: [
      "#ffffff",
      "#efefef",
      "#dcdcdc",
      "#bdbdbd",
      "#989898",
      "#7c7c7c",
      "#656565",
      "#525252",
      "#464646",
      "#3d3d3d",
    ],
  },
  primaryColor: "primary",
};

export default mantineTheme;
